import React, { Component } from 'react';
import Modal from '../Modal/Modal';
import { getDataByUniqueModalName } from '../Modal/modalViewState';
import { transactionShape } from '../../utils/propTypes';
import { arrayOfStringsToStringWithSeparator, prettifyDate } from '../../utils/string';
import { connect } from 'react-redux';
import { voidTransaction } from './voidActions';
import PropTypes from 'prop-types';
import { EmvioValidatedButton, EmvioValidatedForm } from '@nexio/emvio-form-components';
import { currencyMapper, doesPropExistAndHasItChanged, prettifyMoney, asyncGatewayList } from '@nexio/emvio-util-app';
import { getIsVoidLoadingById, getIsVoidSuccessfulById, getVoidErrorMessageById } from '../Void/voidEntity';
import _ from 'lodash';
import { toggleModal } from '../Modal/modalActions';
import { toast } from 'react-toastify';
import './Void.scss';

export class Void extends Component {
    static propTypes = {
        error: PropTypes.string,
        isLoading: PropTypes.bool,
        isSuccessful: PropTypes.bool,
        onToggleModal: PropTypes.func,
        onVoidTransaction: PropTypes.func,
        transaction: transactionShape
    };

    static defaultProps = {
        transaction: {}
    };

    constructor(props) {
        super(props);

        this.handleVoid = this.handleVoid.bind(this);
    }

    componentDidUpdate(prevProps) {
        const gatewayType = _.get(this.props, 'transaction.gateway.gatewayType');
        const asyncGateway = _.find(asyncGatewayList, { gatewayType });
        const voidIsAsync = _.get(asyncGateway, 'voidIsAsync') || false;
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isSuccessful') && this.props.isSuccessful === true) {
            this.props.onToggleModal(this.props.transaction);
            const toastMessage = voidIsAsync ? 'Void request received' : 'Void successful';
            toast(toastMessage, { type: 'success' });
        }
    }

    renderAttribute(title = '', value) {
        if (value) {
            return (
                <div className="attribute">
                    <div className="title">{title.toUpperCase()}</div>
                    <div className={`value ${title === 'Amount' ? 'large' : ''}`}>{value}</div>
                </div>
            );
        }

        return null;
    }

    handleVoid(e) {
        e.preventDefault();

        if (!this.props.isLoading) {
            this.props.onVoidTransaction(this.props.transaction);
        }
    }

    render() {
        const { transaction } = this.props;

        const customerFirstName = _.get(transaction, 'customer.firstName', '');
        const customerLastName = _.get(transaction, 'customer.lastName', '');
        const customerName = arrayOfStringsToStringWithSeparator([customerFirstName, customerLastName]);

        const amount = _.get(transaction, 'foreignProcessingCurrency.amount') || _.get(transaction, 'amount');
        const currencyId = _.get(transaction, 'foreignProcessingCurrency.currencyId') || _.get(transaction, 'currencyId', '840');
        const currency = currencyMapper[currencyId].code;

        return (
            <Modal uniqueModalName="void" title="Void Transaction">
                <EmvioValidatedForm className="emvio-void-popup" onSubmit={this.handleVoid}>
                    {this.renderAttribute('Customer', customerName)}
                    {this.renderAttribute('Date', prettifyDate(transaction.transactionDate, { returnDateOnly: true }))}
                    {this.renderAttribute('Reference Number', _.get(transaction, 'gateway.refNumber'))}
                    {this.renderAttribute('Amount', `${prettifyMoney(amount, currency)} ${_.toUpper(currency)}`)}
                    <EmvioValidatedButton
                        invertColors
                        isLoading={this.props.isLoading}
                    >
                        Void Transaction
                    </EmvioValidatedButton>
                </EmvioValidatedForm>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    const transaction = getDataByUniqueModalName(state, 'void');
    const id = _.get(transaction, 'id');

    return {
        error: getVoidErrorMessageById(state, id),
        isLoading: getIsVoidLoadingById(state, id),
        isSuccessful: getIsVoidSuccessfulById(state, id),
        transaction
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: (transaction) => dispatch(toggleModal('void', transaction)),
        onVoidTransaction: (transaction) => dispatch(voidTransaction(transaction))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Void);
